import { SpeiAttemptsByNode } from '@app/domain/models/spei/spei-attempts-by-node';
import {
  CardsSpeiBatchDoubts,
  CardsSpeiBatchKeys,
  CardsSpeiIndividualAttemptKeys,
} from '@app/domain/models/cards/cards-spei-attempt-memory';

/**
 * Memoria de intentos por nodo de las órdenes SPEI de Cards (feature 124).
 *
 * ⚠️ Se enlaza UNA vez en la raíz (`app.config.ts`, `useExisting` al singleton de
 * la pestaña). Proveerla en una página o en `provideCardsSpeiOrders()` la
 * re-crearía con cada pantalla y volvería a estrenar llave al salir y volver (el
 * doble SPEI que esta feature cierra).
 */
export abstract class CardsSpeiAttemptMemory {
  abstract readonly orders: SpeiAttemptsByNode<CardsSpeiIndividualAttemptKeys>;
  abstract readonly batches: SpeiAttemptsByNode<CardsSpeiBatchKeys>;
  /** Lotes con desenlace desconocido por nodo y huella (feature 122, R16): sin eliminar filas. */
  abstract readonly batchDoubts: CardsSpeiBatchDoubts;
  /** Cierre de sesión: borra los intentos de los dos tipos y las marcas de duda. */
  abstract clear(): void;
}
